import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/firebase-app';

const functions = getFunctions(app);

export const EMAIL_NOT_FOUND_MESSAGE =
  'Ni bilo mogoče najti enoličnega računa. Preverite podatke ali se obrnite na skrbnika organizacije.';

const RECOVERY_SERVICE_ERROR_MESSAGE =
  'Iskanje elektronskega naslova trenutno ni mogoče. Poskusite znova pozneje.';

function mapRecoveryError(error) {
  const code = error?.code || '';
  const message = error?.message || '';

  if (code === 'functions/invalid-argument') {
    return message.replace(/^FirebaseError:\s*/i, '') || 'Neveljavni podatki.';
  }
  if (code === 'functions/not-found') {
    return message.replace(/^FirebaseError:\s*/i, '') || 'Organizacija ni na voljo.';
  }
  if (code === 'functions/unavailable') {
    return RECOVERY_SERVICE_ERROR_MESSAGE;
  }

  return RECOVERY_SERVICE_ERROR_MESSAGE;
}

export async function lookupForgottenEmail({ tenantId, firstName, lastName, phone }) {
  try {
    const callable = httpsCallable(functions, 'lookupForgottenEmail');
    const result = await callable({ tenantId, firstName, lastName, phone });
    return result.data || { found: false };
  } catch (error) {
    throw new Error(mapRecoveryError(error));
  }
}
